import { render, staticRenderFns } from "./actionNotification.vue?vue&type=template&id=4d110cc0"
import script from "./actionNotification.vue?vue&type=script&lang=js"
export * from "./actionNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports